import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-venue-closed-modal',
	templateUrl: './venue-closed-modal.component.html',
	styleUrls: ['venue-closed-modal.component.scss'],
})
export class VenueClosedModalComponent implements OnInit, OnDestroy {
	title: string;
	message: string;

	constructor(
		private modalCtrl: ModalController,
		public translate: TranslateService
	) {}

	static async show(modalCtrl: ModalController, title: string = '', message: string = ''): Promise<boolean> {
		const modal = await modalCtrl.create({
			cssClass: 'info-modal auto-height',
			component: VenueClosedModalComponent,
			componentProps: {
				title,
				message,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	ngOnInit() {}
	ngOnDestroy(): void {}

	public dismiss() {
		this.modalCtrl.dismiss();
	}
}
